import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BaseGeneralComponent} from "../../BaseGeneralComponent";
import {Observable, Subscription} from "rxjs";
import {Offset} from "../../../models/Offset";
import {ForecastVolumiModel} from "../../../models/ForecastVolumiModel";
import {ForecastVolumiService} from "./service-forecast-volumi/forecast-volumi.service";
import {NumAnnoMeseService} from "../../general-services/service-num-anno-mese/num-anno-mese.service";
import {LoaderService} from "../../general-services/service-loader/loader.service";
import {Router} from "@angular/router";
import {ProviderModel} from "../../../models/ProviderModel";
import {ContractTypeService} from "../../general-services/service-contract-type/contract-type.service";
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {GenericArray} from "../../../models/GenericArray";
import {DialogDetailComponent} from "../../general-components/dialog-detail/dialog-detail.component";

@Component({
  selector: 'app-forecast-volumi',
  templateUrl: './forecast-volumi.component.html',
  styleUrls: ['./forecast-volumi.component.scss']
})
export class ForecastVolumiComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  displayedColumns: Array<string>;
  dataSource: any;
  selectedRowIndex: number;
  isForecastSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ForecastVolumiModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  numAnnoMese: any;
  showFilter: boolean;

  @Input() reportSection?: boolean;
  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private forecastVolumiService: ForecastVolumiService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    this.loaderService.display(true);
    this.isForecastSection = this.returnIsContractSection(this.router.url);

    this.displayedColumns = ['numAnnoMese', 'region', 'localCustomer', 'contractType', 'provider',
      'resourceUnitName', 'expectedVol', 'useExpectedVol', 'actions'];
    this.selectedRowIndex = -1;

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.FORECAST_VOLUMI_OFFSET);
    this.getSessionStorageFilter();
    this.setDefaultOrderField();
    this.init();
  }

  init() {
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        if (!this.filter.numAnnoMese) {
          const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }

        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }          }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  getDataPage(offset: Offset, filter: ForecastVolumiModel) {
    this.getPageSubscribe = this.forecastVolumiService.getPage(offset, filter)
      .subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const forecastVolumiData = this.dataSource.find(data => data.id === id) as ForecastVolumiModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(forecastVolumiData.numAnnoMese)},
      {id: 'Provider Cod', value: this.toCustomString(forecastVolumiData.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(forecastVolumiData.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(forecastVolumiData.region.cod) },
      {id: 'Region Description', value: this.toCustomString(forecastVolumiData.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(forecastVolumiData.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(forecastVolumiData.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString(forecastVolumiData.contractType.cod)},
      {id: 'Contract Type Description', value: this.toCustomString(forecastVolumiData.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString(forecastVolumiData.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString(forecastVolumiData.resourceUnit.name)},
      {id: 'Expected Volume', value: this.toCustomString(forecastVolumiData.expectedVol )}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.FORECAST_VOLUMI_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    this.setDefaultOrderField();
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  setDefaultOrderField() {
    if (this.offset.orderField === null || this.offset.orderField === undefined || this.offset.orderField === '') {
      this.offset.orderField = 'contractType';
      this.offset.orderDirection = 'asc';
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.FORECAST_VOLUMES_FILTER));
    this.filter = filter_ ? filter_ : new ForecastVolumiModel();
  }
}
